<template>
  <div id="box" class="box"  @mouseover="boxMouseover" @mouseleave="boxMouseleave">
    <div class="title" :class="direction ? 'left' : 'right'">{{ title }}</div>
    <div class="content"  :class="direction ? 'left-content' : 'right-content'">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "box",
  props: {
    title: {
      typeof: String,
      default: "区域风场",
    },
    direction: {
      typeof: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods:{
    boxMouseover(){
      console.log("aaaa");
      this.$emit("boxMouseover")
    },
    boxMouseleave(){
      console.log("bbb");
      this.$emit("boxMouseleave")
    }
  }
};
</script>

<style lang="scss" scoped>
#box {
  width: 400px;
  .title {
    width: 100%;
    min-width: 180px;
    height: 60px;
    background-size: 100% 100%;
    color: white;
    font-size: 20px;
    letter-spacing: 3px;
    font-style: italic;
    padding-top: 10px;
  }
  .left {
    background-image: url("@/assets/image/box/left_bj.png");
    padding-left: 26%;
    text-align: left;
  }
  .right {
    background-image: url("@/assets/image/box/right_bj.png");
    padding-right: 26%;
    text-align: right;
  }
  .left-content{
    > div {
      margin-left: 20px;
      margin-top: 10px;
    }
  }
  .right-content{
    > div {
      margin-right: 20px;
      margin-top: 10px;
    }
  }
  .content {
    width: 100%;
  }
}
</style>
